import { render, staticRenderFns } from "./missinggeos.vue?vue&type=template&id=0d84ac9d&"
import script from "./missinggeos.vue?vue&type=script&lang=js&"
export * from "./missinggeos.vue?vue&type=script&lang=js&"
import style0 from "./missinggeos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports